export const formatRemaining = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.round(ms / 1000));
  if (totalSeconds < 5) return 'a few seconds left';
  if (totalSeconds < 60) return `${totalSeconds}s left`;
  const minutes = Math.round(totalSeconds / 60);
  if (minutes < 60) return `${minutes}m left`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m left` : `${hours}h left`;
};

/** Extrapolates remaining time from elapsed time and current progress (e.g. 30% in 10s → ~23s left). */
export const estimateRemaining = (startedAt: number, progress: number): string | null => {
  if (progress <= 0 || progress >= 100) return null;

  const elapsed = Date.now() - startedAt;
  if (elapsed <= 0) return null;

  const estimatedTotal = elapsed / (progress / 100);
  return formatRemaining(estimatedTotal - elapsed);
};
